export default function postToEmbedParent(message) {
  if (!import.meta.client || window.parent === window) return;
  window.parent.postMessage(message, useEmbedParentOrigin() || '*');
}
